export default {
      id: "about-icon-4_color-usage",
      viewBox: "0 0 80 80",
      url: __webpack_public_path__ + "sprite.svg#about-icon-4_color",
      toString: function () {
        return this.url;
      }
    }